import baseControllerInput from './baseControllerInput'
import { REQUIRED_ERROR_MESSAGE } from 'messages'

const REGEX = [/[0-8]/]

export default baseControllerInput({
  getErrorMessage: state => {
    return state.input.value.length === 1 ? '' : REQUIRED_ERROR_MESSAGE
  },
  maskConfig: {
    mask: REGEX,
    guide: false
  }
})
